import { render, staticRenderFns } from "./example_speech_to_text.config.vue?vue&type=template&id=34cd5da2"
import script from "./example_speech_to_text.config.vue?vue&type=script&lang=js"
export * from "./example_speech_to_text.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports